exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outlet-details[data-v-769385c6]{text-align:center}.outlet-tags[data-v-769385c6]{text-align:center;padding-left:0}.outlet-tags li[data-v-769385c6]{display:inline-block;margin-left:2px;margin-right:2px}.outlet-tags li[data-v-769385c6]:not(:last-child):after{content:\" |\"}.postcode-list[data-v-769385c6]{width:100%;margin-top:15px}.postcode-list ul[data-v-769385c6]{margin-top:5px;list-style:none;padding-left:0}.order-options-list ons-list-item .left[data-v-769385c6]{align-items:flex-start}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-769385c6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/outlets/tabs/opening_times.vue
// module id = nwy7
// module chunks = 0